import { no_img } from "assets";
import React from "react";

const Image = ({ alt, src, className }) => {
  return (
    <img
      className={`h-[40px] max-w-[50px] object-contain ${className}`}
      alt={alt || src}
      src={src || no_img}
    />
  );
};

export default Image;
